// extracted by mini-css-extract-plugin
export default {"root":"C2uA4ihc45V9yXd19EdQ","img":"cVOcmpIeEAWhyHgUOXoP"};